<template>
  <div>
    <div class="air__utils__heading">
      <h5>Google Meet Links</h5>
    </div>
    <a-card>
      <a-alert type="info" message="Coming Soon" description="The interface to manage Google Meet links directly will be implemented here. Currently, Meet links are automatically generated when teachers initiate a class." showIcon />
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>
